export function PersonnelData() {
    return {
        "deviceCount": 61,
        "carCount": 24,
        "tunnelCount": 33,
        "personCount": 3659
    }
}